<template>
  <div>
    <!-- Automate Scripts Panel -->
    <div
      v-if="scriptToggle"
      class="script-options menu-bg-blue-transparent"
      title="Admin Only Feature"
    >
      <div class="py-2 my-2" no-body>
        <b-link @click="toggleDRTAutomation()" class="ml-3 admin-text">
          DRT/ANSI Automation
        </b-link>
        <hr class="" />
        <b-link @click="toggleDPRAutomation()" class="ml-3 admin-text">
          DPR Automation
        </b-link>
      </div>
    </div>

    <!-- Main Features Panel -->
    <div class="home-options menu-bg-blue-transparent">
      <div class="py-2 my-2" no-body>
        <b-link
          v-if="globalIsUserAllowed('Change_Password')"
          @click="initChangePasswordModal()"
          class="ml-3 white"
          :disabled="disableForTestAccounts()"
          :title="
            disableForTestAccounts()
              ? 'Cannot change password of test account'
              : ''
          "
        >
          Change Password
        </b-link>
        <hr class="" v-if="globalIsUserAllowed('Map_Settings')" />
        <b-link v-if="globalIsUserAllowed('Map_Settings')" @click="initMapSettingsMenuModal()" class="ml-3 white">
          Map Settings
        </b-link>
        <hr class=""  v-if="globalIsUserAllowed('Release_History')"/>
        <b-link v-if="globalIsUserAllowed('Release_History')" @click="toggleReleaseHistory()" class="ml-3 white">
          Release History
        </b-link>
        <div
          title="Admin Only Feature"
          id="adminOnlyFeatures"
        >
          <hr class="" v-if="globalIsUserAllowed('UAC')"/>
          <b-link v-if="globalIsUserAllowed('UAC')" @click="toggleUAC()" class="ml-3 admin-text">
            User Account Control
          </b-link>
          <hr class="" v-if="globalIsUserAllowed('Access_Control')"/>
          <b-link v-if="globalIsUserAllowed('Access_Control')" @click="toggleAccessControlModal()" class="ml-3 admin-text">
            Access Control
          </b-link>
          <hr class="" v-if="globalIsUserAllowed('Release_Version')"/>
          <b-link v-if="globalIsUserAllowed('Release_Version')" @click="toggleVersionRelease()" class="ml-3 admin-text">
            Release Version
          </b-link>
          <hr class="" v-if="globalIsUserAllowed('MMP_Deliveries')"/>
          <b-link v-if="globalIsUserAllowed('MMP_Deliveries')" @click="toggleDeliveryModal()" class="ml-3 admin-text">
            MMP Deliveries
          </b-link>
          <hr class="" v-if="globalIsUserAllowed('Automate_Scripts')"/>
          <b-link v-if="globalIsUserAllowed('Automate_Scripts')" @click="toggleScripts()" class="ml-3 admin-text">
            Automate Scripts
            <fa :icon="['fas', 'chevron-right']" class="ml-4" />
          </b-link>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.white.disabled {
  opacity: 0.45;
  cursor: not-allowed;
}
</style>

<script>
import { mapGetters, mapActions } from 'vuex';
export default {
  name: 'MMP_MainFeatureButtons',
  props: ['isAdmin', 'user'],
  computed: {
    ...mapGetters(['globalUserRole','globalAllowedUserModules','globalIsUserAllowed'])
  },
  data() {
    return {
      scriptToggle: false
    }
  },
  methods: {
    toggleVersionRelease() {
      this.$bvModal.show('versionReleaseModal')
    },
    toggleDeliveryModal() {
      this.$bvModal.show('deliveriesModal')
    },
    toggleAccessControlModal() {
      this.$bvModal.show('AccessControlModal')
    },
    toggleScripts() {
      this.scriptToggle = !this.scriptToggle
    },
    toggleUAC() {
      this.$bvModal.show('UACModal')
    },
    toggleDRTAutomation() {
      this.$bvModal.show('ScriptSettings')
    },
    toggleDPRAutomation() {
      this.$bvModal.show('DPRScripts')
    },
    toggleReleaseHistory() {
      this.$bvModal.show('HistoryModal')
    },
    initChangePasswordModal() {
      this.$bvModal.show('ChangePasswordModal')
    },
    initMapSettingsMenuModal() {
      this.$bvModal.show('MapSettingsMenu')
    },
    disableForTestAccounts() {
      // REFACTORED -- WEBGIS-2605 -- originally had this.userIsTestAccount (which is not a variable or prop) - changed to use test attribute of user variable
      return this.user.test
    }
  }
}
</script>
